import { createTheme } from '@mui/material';

import { theme as coreTheme } from '@lendica/theme';

export const theme = createTheme(coreTheme, {
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#F2EDE8',
                },
            },
        },
    },
});
